import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines = [], delay = 0, lineClassName = "", immediate = true }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const show = immediate || inView;

  return (
    <span ref={ref} className="block">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={show ? { y: "0%" } : { y: "115%" }}
            transition={{ duration: 1.05, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Fade({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <Fade y={12}>
      <p className={`text-xs uppercase tracking-[0.28em] font-medium text-burgundy ${className}`} data-testid="section-overline">
        {children}
      </p>
    </Fade>
  );
}
